import React, { Fragment } from 'react'
import { getStartedStyle as styles } from './getStarted.tailwind'
import getStartedData from './getStarted.data'
import GetStartedBox from './GetStartedBox'
import arrow from '../../../assets/svgs/get_started_arrow.svg'

const GetStarted = () => {
  return (
    <section className={styles.component_wrapper}>
      <h1 className='landing_page_sub_heading'>Get Started</h1>

      {/* Tokens */}
      <div className={styles.token_card_wrpr}>
        {/* Tokens List */}
        {getStartedData.map((data, key) => (
          <Fragment key={key}>
            <GetStartedBox key={key} data={data} />
            {/* Arrow will not be visible for last one. */}
            {key !== (getStartedData.length - 1) && <img src={arrow} alt='arrow' className={styles.arrow}  />}
          </Fragment>
        ))}
      </div>
    </section>
  )
}

export default GetStarted